import type { core } from 'zod'

/**
 * Error map that names a missing value `Required`. Any other issue keeps its
 * own message. Pass it as the `error` parse param wherever a form parses with
 * zod directly.
 */
export const missingAsRequired = (issue: core.$ZodRawIssue) =>
  issue.input === undefined &&
  (issue.code === 'invalid_type' || issue.code === 'invalid_value')
    ? 'Required'
    : undefined
